/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type TranscriptItemState =
	(typeof TranscriptItemState)[keyof typeof TranscriptItemState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TranscriptItemState = {
	not_sent: 'not_sent',
	sent: 'sent',
	processed: 'processed',
	errored: 'errored',
} as const;
